import { DeviceType } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

const DESKTOP_SELECTION_IMAGE = '/assets/images/desktop-selection.png';
const MOBILE_SELECTION_IMAGE = '/assets/images/mobile-selection.png';

export const DeviceTypeController: React.FC = () => {
  const { togglePreviewDeviceLayout, previewDeviceLayout } =
    useTemplateStudioState();

  return (
    <div
      className="cursor-pointer w-[70px] h-[36px]"
      onClick={togglePreviewDeviceLayout}
    >
      <img
        src={
          previewDeviceLayout === DeviceType.DESKTOP
            ? DESKTOP_SELECTION_IMAGE
            : MOBILE_SELECTION_IMAGE
        }
        alt={'selection'}
        className="object-cover"
      />
    </div>
  );
};
